import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function getSystemInfo(){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_SYSTEMINFO_REQUESTED", "GET_SYSTEMINFO_SUCCESS", "GET_SYSTEMINFO_FAILED"],
        method: "POST",
        path: "admin/system_info",
        body: data
    });
}

export function getLicenses(){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_LICENSES_REQUESTED", "GET_LICENSES_SUCCESS", "GET_LICENSES_FAILED"],
        method: "POST",
        path: "admin/get_licenses",
        body: data
    });
}


export function addLicense(data){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let postData = {};
    postData.license_key = data.license_key;
    appendTokenName(postData);
    return apiAction({
        types: ["ADD_LICENSE_REQUESTED", "ADD_LICENSE_SUCCESS", "ADD_LICENSE_FAILED"],
        method: "POST",
        path: "admin/add_license",
        body: postData
    });
}

export function setLicensePageInfo({pageSize,pageNo}){
    return {
        type : 'SET_LICENSE_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export function deleteLicense(data){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let postData = {};
    postData.license_id = data.licenseId;
    appendTokenName(postData);
    return apiAction({
        types: ["DELETE_LICENSE_REQUESTED", "DELETE_LICENSE_SUCCESS", "DELETE_LICENSE_FAILED"],
        method: "POST",
        path: "admin/delete_license",
        body: postData
    });
}


// WEBPACK FOOTER //
// ./src/actions/actionSystemInfo.js